import { Star } from "lucide-react";

export const Stars = ({ value = 0, size = "sm", testId }) => {
  const px = size === "lg" ? "h-5 w-5" : "h-3.5 w-3.5";
  return (
    <span className="inline-flex items-center gap-0.5" data-testid={testId}>
      {[1, 2, 3, 4, 5].map((i) => (
        <Star
          key={i}
          className={`${px} ${i <= Math.round(value) ? "fill-amber-400 text-amber-400" : "text-slate-300"}`}
        />
      ))}
    </span>
  );
};

export const RatingSummary = ({ average, count, size = "sm", testId }) => {
  if (!count) {
    return <span className="text-xs text-slate-400" data-testid={testId}>No ratings yet</span>;
  }
  return (
    <span className="inline-flex items-center gap-2" data-testid={testId}>
      <Stars value={average} size={size} />
      <span className={size === "lg" ? "text-sm font-semibold text-slate-800" : "text-xs font-semibold text-slate-700"}>
        {Number(average).toFixed(1)} ({count})
      </span>
    </span>
  );
};

export const StarPicker = ({ value, onChange, testId }) => (
  <div className="flex items-center gap-1.5" data-testid={testId}>
    {[1, 2, 3, 4, 5].map((i) => (
      <button
        key={i}
        type="button"
        onClick={() => onChange(i)}
        data-testid={`star-${i}`}
        className="transition-transform hover:scale-110"
        aria-label={`${i} star${i === 1 ? "" : "s"}`}
      >
        <Star className={`h-7 w-7 ${i <= value ? "fill-amber-400 text-amber-400" : "text-slate-300"}`} />
      </button>
    ))}
  </div>
);

export const ESCROW_TONE = {
  UNFUNDED: "border-slate-200 bg-slate-50 text-slate-600",
  FUNDED: "border-sky-200 bg-sky-50 text-sky-700",
  PENDING_RELEASE: "border-amber-200 bg-amber-50 text-amber-700",
  DISPUTED: "border-red-200 bg-red-50 text-red-700",
  RELEASING: "border-sky-200 bg-sky-50 text-sky-700",
  RELEASED: "border-emerald-200 bg-emerald-50 text-emerald-700",
  REFUNDED: "border-orange-200 bg-orange-50 text-orange-700",
};

export const EscrowChip = ({ status = "UNFUNDED", dueAt, testId }) => {
  const label = status === "PENDING_RELEASE" && dueAt ? `releases ${new Date(dueAt).toLocaleString()}` : status.toLowerCase().replaceAll("_", " ");
  return (
    <span
      className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-[11px] font-semibold ${ESCROW_TONE[status] || ESCROW_TONE.UNFUNDED}`}
      data-testid={testId}
    >
      Escrow: {label}
    </span>
  );
};
